// extracted by mini-css-extract-plugin
export var quillEditor = "_kn-1";
export var variable = "_kn-0";